import React, { useEffect, useState } from 'react';
import { Modal, Box, TextField, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import apiUrl from '@common/utils/apiURL';
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { isUserLoggedIn, setUserToken } from '@common/utils/auth/authService';
import axiosInstance from '@common/utils/axiosInstance';
import { useDispatch, useSelector } from 'react-redux';
import { closeSignInModal, selectSignInModalState, openSignInModal } from 'store/slices/authSlice';
import { AdvancedImage } from '@cloudinary/react';
import { Cloudinary } from "@cloudinary/url-gen";
import { format } from '@cloudinary/url-gen/actions/delivery';
import companyLogo from '@assets/images/logo-white.svg';
import { getAuthHeaders } from '@common/utils/cart';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

function SignInModal() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isModalOpen = useSelector(selectSignInModalState);
  const postSignInCallback = useSelector((state) => state.auth.postSignInCallback);

  const handleBackdropClick = (event) => {
    // Prevent close when the backdrop is clicked
    event.stopPropagation();
  };

  const cld = new Cloudinary({
    cloud: {
      cloudName: 'dci1aiukm'
    }
  });

  const myImage = cld.image('login-img').quality('auto').delivery(format('webp'));

  const [open, setOpen] = useState(false);
  useEffect(() => {
    setOpen(isModalOpen);
  }, [isModalOpen]);

  const handleOpen = () => {
    if (isUserLoggedIn()) {
      navigate('/profile')
    } else {
      dispatch(openSignInModal());
    }
  };
  const handleClose = () => {
    dispatch(closeSignInModal());
    if (postSignInCallback) {
      postSignInCallback();  // 🔥 Call the stored callback
    }
  };

  const handleModalClose = (event, reason) => {
    // This is where you can handle close when clicking the modal button, etc.
    if (reason === 'backdropClick') {
      // Do nothing to prevent closing on backdrop click
      return;
    }
    handleClose();
  };

  const [showSignUp, setShowSignUp] = useState(false);
  const [forgotPasswordFormik, setForgotPasswordFormik] = useState({
    email: '',
  });

  const showSignUpModalHandle = () => {
    setShowSignUp(true);
  }

  const showSignInModalHandle = () => {
    setShowSignUp(false);
  }

  const [showForgotPassWordForm, setShowForgotPassWordForm] = useState(false);

  const showForgotPassWordFormHandle = async () => {
    setShowForgotPassWordForm(true);
  }

  const hideForgotPassWordFormHandle = () => {
    setShowForgotPassWordForm(false);
  }

  const [successOpen, setSuccessOpen] = useState(false);

  const successHandleModalClose = () => {
    setSuccessOpen(false);
  }

  const successHandleModalOpen = async (e) => {
    e.preventDefault();
    // setSuccessOpen(true);
    console.log(forgotPasswordFormik.email)
    try {
      const headers = getAuthHeaders();
      const response = await axiosInstance.post(apiUrl.auth.forgotPassword, { email: forgotPasswordFormik.email }, { headers })
      if (response.status === 200) {
        toast.success('Password reset successfully!');
        window.location.href = window.location.origin + '/login';
      }
    } catch (error) {
      console.log(error.response.data)
      if (error?.response?.status === 405) {
        toast.error(error?.response?.data?.message)
      } else if (error?.response?.status !== 401) {
        toast.error('Error resetting password, please try again');
      }
      console.error("Error resetting password:", error);
    }
  }

  const signInFormik = useFormik({
    initialValues: {
      username: '',
      password: '',
    },
    validationSchema: Yup.object({
      username: Yup.string()
        .required('Username is required')
        .matches(
          /^[0-9]{10}$|^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          'Must be a valid email or mobile number'
        ),
      password: Yup.string()
        .required('Password is required'),
    }),
    onSubmit: async (values) => {
      handleSignIn(values.username, values.password, 'Logged In Successfully!');
    },
  });

  const handleSignIn = async (username, password, msg) => {
    try {
      const payload = {
        "email": username,
        "password": password,
      }
      const response = await axiosInstance.post(apiUrl.auth.login, payload);
      if (response.status === 200) {
        document.cookie = `access_token=${response.data.accessToken}; path=/; max-age=${7 * 24 * 60 * 60}; secure; samesite=strict`;
        setUserToken(response.data.accessToken);
        toast.success(msg);
        signInFormik.resetForm();
        signUpFormik.resetForm();
        handleClose();
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  }

  // Formik for Sign Up form
  const signUpFormik = useFormik({
    initialValues: {
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      role: 'CUSTOMER',
      password: '',
    },
    validationSchema: Yup.object({
      firstName: Yup.string()
        .required('First name is required'),
      lastName: Yup.string(),
      phone: Yup.string()
        .required('Mobile number is required')
        .matches(/^[0-9]{10}$/, 'Mobile number must be 10 digits'),
      email: Yup.string()
        .required('Email is required')
        .email('Invalid email address'),
      password: Yup.string()
        .required('Password is required'),
    }),
    onSubmit: async (values) => {
      try {
        let URL = '';
        if (localStorage.getItem('isGuestUser') === "true") {
          URL = apiUrl.auth.guestRegister;
        } else {
          URL = apiUrl.auth.register;
        }
        const response = await axiosInstance.post(URL, values);
        if (response.status === 200) {
          // toast.success('Sign Up Successful!, Please log in to continue');
          if (localStorage.getItem('isGuestUser') === "false") {
            handleSignIn(values.email, values.password, 'Sign Up Successful!');
          } else {
            toast.success('Sign Up Successful!');
            // console.log('response', response);
            setUserToken(response.data.accessToken);
            handleClose();
          }
          // showSignInModalHandle();
          // handleClose();
        }
      } catch (error) {
        toast.error(error.response.data.message);
      }
    },
  });


  //dropdown menu
  const [anchorElMenu, setAnchorElMenu] = useState(null);
  const openMenu = Boolean(anchorElMenu);
  const handleClickOpenMenu = (event) => {
    setAnchorElMenu(event.currentTarget);
  };
  const handleClickCloseMenu = () => {
    setAnchorElMenu(null);
  };

  //logout
  const location = useLocation();

  const handleLogout = () => {
    handleClickCloseMenu();
    localStorage.clear();
    toast.success('Logged Out Successfully!')
    navigate('/');
  }

  return (
    <>
      {isUserLoggedIn() ? (
        <button className='bs-btn bs-btn__btn-icon bs-btn__btn-icon--active bs-header__action cm-hidden-flex-xs' onClick={handleClickOpenMenu}>
          <span className='icon icon-user'></span>
        </button>
      ) : (
        <button className='bs-btn bs-btn__btn-icon bs-header__action cm-hidden-flex-xs' onClick={handleOpen}>
          <span className='icon icon-user'></span>
        </button>
      )}

      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorElMenu}
        open={openMenu}
        onClose={handleClickCloseMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        className='bs-dropdown-menu'
      >
        <MenuItem
          onClick={() => {
            handleClickCloseMenu();
            navigate('/profile');
          }}
          className='bs-dropdown-menu__menu-item'
        >
          <ListItemIcon className='bs-dropdown-menu__menu-item-icon'>
            <span className='icon icon-user-circle'></span>
          </ListItemIcon>
          <ListItemText className='bs-dropdown-menu__menu-item-text'>Profile</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClickCloseMenu();
            navigate('/my-orders');
          }}
          className='bs-dropdown-menu__menu-item'
        >
          <ListItemIcon className='bs-dropdown-menu__menu-item-icon'>
            <span className='icon icon-cart-line'></span>
          </ListItemIcon>
          <ListItemText className='bs-dropdown-menu__menu-item-text'>My orders</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleLogout();
          }}
          className='bs-dropdown-menu__menu-item'
        >
          <ListItemIcon className='bs-dropdown-menu__menu-item-icon'>
            <span className='icon icon-logout'></span>
          </ListItemIcon>
          <ListItemText className='bs-dropdown-menu__menu-item-text'>logout</ListItemText>
        </MenuItem>
      </Menu>


      <Modal
        open={open}
        onClose={handleModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className='bs-modal bs-modal--typ-form'

      >
        <Box className={`bs-modal__wrapper bs-banner-form ${showForgotPassWordForm ? 'bs-banner-form__typ-forgot-pass' : ''} ${showSignUp ? 'bs-banner-form__typ-sign-up' : ''}`} sx={style} onClick={handleBackdropClick}>
          <button className='bs-modal__close  bs-banner-form__close-btn' onClick={handleModalClose}>
            <span className='icon icon-simple-close'></span>
          </button>
          <div className='bs-banner-form__body'>
            <div className='bs-banner-form__media-wrap'>
              <AdvancedImage cldImg={myImage} loading="lazy" className='bs-banner-form__image' />
              <div className='bs-banner-form__logo'>
                <img width="100%" height="100%" src={companyLogo} alt="Company logo" />
              </div>
            </div>
            <div className={`bs-banner-form__cont-wrap bs-banner-form__cont-wrap--no-flex`}>

              {
                showForgotPassWordForm ? (
                  <>
                    <div className='bs-modal__content'>
                      <h2 className='bs-modal__title'>Forgot password</h2>
                      <p className='bs-modal__title-desc'>Enter your email and we’ll send you a link to reset your password.</p>
                      <form className='bs-form bs-form--typ-column'>
                        <div className={`bs-form__form-group`}>
                          <TextField
                            id="emailId"
                            name="emailId"
                            value={forgotPasswordFormik.email}
                            onChange={(e) => setForgotPasswordFormik({ ...forgotPasswordFormik, email: e.target.value })}
                            type="email"
                            label="Email Id"
                            className='bs-form__form-control'
                          />
                        </div>
                        <div className={`bs-form__form-bottom-wrap`}>
                          <div className='bs-form__form-bottom-wrap--col'>
                            <button
                              className='bs-btn bs-btn__btn-solid bs-btn__btn-solid--typ-xxl'
                              onClick={successHandleModalOpen}
                            >
                              Send reset link
                            </button>
                          </div>
                          <button className='bs-btn bs-btn__btn-link mod-text-btn__link' onClick={hideForgotPassWordFormHandle}>back to sign in</button>
                        </div>
                      </form>
                    </div>
                  </>
                ) :
                  <>
                    <h2 className='bs-modal__title'>{!showSignUp ? 'sign-in' : 'sign-up'}</h2>
                    {!showSignUp ? (
                      <>
                        <div className='bs-modal__content'>
                          <form className='bs-form bs-form--typ-column' onSubmit={signInFormik.handleSubmit}>
                            <div className={`bs-form__form-group`}>
                              <TextField
                                id="username"
                                name="username"
                                value={signInFormik.values.username}
                                onChange={signInFormik.handleChange}
                                onBlur={signInFormik.handleBlur}
                                type="text"
                                label="Email / Mobile Number"
                                className='bs-form__form-control'
                                error={signInFormik.touched.username && Boolean(signInFormik.errors.username)}
                                helperText={signInFormik.touched.username && signInFormik.errors.username}
                              />
                            </div>
                            <div className={`bs-form__form-group bs-form__form-group--with-link`}>
                              <TextField
                                id="password"
                                name="password"
                                value={signInFormik.values.password}
                                onChange={signInFormik.handleChange}
                                onBlur={signInFormik.handleBlur}
                                type="password"
                                label="Password"
                                className='bs-form__form-control'
                                error={signInFormik.touched.password && Boolean(signInFormik.errors.password)}
                                helperText={signInFormik.touched.password && signInFormik.errors.password}
                              />
                              <button
                                className='bs-btn bs-btn__btn-icon-link bs-btn__btn-icon-link--decoration-underline'
                                onClick={showForgotPassWordFormHandle}
                              >
                                <span className='bs-btn__btn-text'>forgot password ?</span>
                              </button>
                            </div>
                            <div className={`bs-form__form-bottom-wrap`}>
                              <div className='bs-form__form-bottom-wrap--col'>
                                <button className='bs-btn bs-btn__btn-solid bs-btn__btn-solid--typ-xxl' type="submit">
                                  Continue
                                </button>
                                <button className='bs-btn bs-btn__btn-solid bs-btn__btn-solid--typ-xxl bs-btn__btn-solid--inverse-border' onClick={handleClose}>as a guest</button>
                              </div>
                              {/* <button className='bs-btn bs-btn__btn-border bs-btn__btn-icon-text' type='submit'>
                          <span className='bs-btn__icon icon-google'></span>
                          <span className='bs-btn__btn-text'>sign in with google</span>
                        </button>  */}
                            </div>
                          </form>
                        </div>
                        <div className='bs-modal__footer-wrap'>
                          <div className='mod-text-btn'>
                            <p className='mod-text-btn__text'>don't have an account ? <button className='bs-btn bs-btn__btn-link mod-text-btn__link' onClick={showSignUpModalHandle}>sign-up</button></p>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className='bs-modal__content bs-modal__content--no-border'>
                          <form className='bs-form bs-form--typ-column' onSubmit={signUpFormik.handleSubmit}>
                            <div className={`bs-form__form-group`}>
                              <TextField
                                id="firstName"
                                name="firstName"
                                value={signUpFormik.values.firstName}
                                onChange={signUpFormik.handleChange}
                                onBlur={signUpFormik.handleBlur}
                                type="text"
                                label="First Name"
                                className='bs-form__form-control'
                                error={signUpFormik.touched.firstName && Boolean(signUpFormik.errors.firstName)}
                                helperText={signUpFormik.touched.firstName && signUpFormik.errors.firstName}
                              />
                            </div>
                            <div className={`bs-form__form-group`}>
                              <TextField
                                id="lastName"
                                name="lastName"
                                value={signUpFormik.values.lastName}
                                onChange={signUpFormik.handleChange}
                                onBlur={signUpFormik.handleBlur}
                                type="text"
                                label="Last Name"
                                className='bs-form__form-control'
                                error={signUpFormik.touched.lastName && Boolean(signUpFormik.errors.lastName)}
                                helperText={signUpFormik.touched.lastName && signUpFormik.errors.lastName}
                              />
                            </div>
                            <div className={`bs-form__form-group`}>
                              <TextField
                                id="phone"
                                name="phone"
                                value={signUpFormik.values.phone}
                                onChange={signUpFormik.handleChange}
                                onBlur={signUpFormik.handleBlur}
                                type="text"
                                label="Mobile Number"
                                className='bs-form__form-control'
                                error={signUpFormik.touched.phone && Boolean(signUpFormik.errors.phone)}
                                helperText={signUpFormik.touched.phone && signUpFormik.errors.phone}
                              />
                            </div>
                            <div className={`bs-form__form-group`}>
                              <TextField
                                id="email"
                                name="email"
                                value={signUpFormik.values.email}
                                onChange={signUpFormik.handleChange}
                                onBlur={signUpFormik.handleBlur}
                                type="email"
                                label="Email ID"
                                className='bs-form__form-control'
                                error={signUpFormik.touched.email && Boolean(signUpFormik.errors.email)}
                                helperText={signUpFormik.touched.email && signUpFormik.errors.email}
                              />
                            </div>
                            <div className={`bs-form__form-group`}>
                              <TextField
                                id="password"
                                name="password"
                                value={signUpFormik.values.password}
                                onChange={signUpFormik.handleChange}
                                onBlur={signUpFormik.handleBlur}
                                type="password"
                                label="Password"
                                className='bs-form__form-control'
                                error={signUpFormik.touched.password && Boolean(signUpFormik.errors.password)}
                                helperText={signUpFormik.touched.password && signUpFormik.errors.password}
                              />
                            </div>
                            <div className={`bs-form__form-bottom-wrap`}>
                              <div className='bs-form__form-bottom-wrap--col'>
                                <button className='bs-btn bs-btn__btn-solid bs-btn__btn-solid--typ-xxl' type="submit">
                                  Continue
                                </button>
                                <button className='bs-btn bs-btn__btn-solid bs-btn__btn-solid--typ-xxl bs-btn__btn-solid--inverse-border' onClick={showSignInModalHandle}>sign in</button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </>
                    )}
                  </>
              }
            </div>
          </div>
        </Box>
      </Modal>

      <Modal
        open={successOpen}
        onClose={successHandleModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className='bs-modal bs-modal--typ-select-address'

      >
        <Box className='bs-modal__wrapper' sx={style} onClick={handleBackdropClick}>
          <div className="bs-success-msg">
            <div className='bs-success-msg__info-wrap'>
              <span className='icon icon-success bs-success-msg__icon'></span>
              <h4 className='bs-success-msg__title'>Reset Link Sent successfully</h4>
              <p className='bs-success-msg__desc'>Check your inbox for instructions to reset your password.</p>
              <p className='bs-success-msg__desc bs-success-msg__desc--txt-sm'>Didn’t get the email? Check your spam folder</p>
            </div>
            <div className='bs-success-msg__action-wrap'>
              <button className='bs-btn bs-btn__btn-solid bs-btn__btn-solid--typ-xxl' onClick={successHandleModalClose}>back to login</button>
            </div>
          </div>
        </Box>
      </Modal>

    </>
  )
}

export default SignInModal